import { PaymentDeferralReason as GqlPaymentDeferralReason } from '@willow/graphql-iso/src/app';
import { assertNever, PaymentDeferralReason } from '@willow/types-iso';

export const getPaymentDeferralReasonLabel = (reason: PaymentDeferralReason | GqlPaymentDeferralReason): string => {
  switch (reason) {
    case 'hardship':
    case GqlPaymentDeferralReason.Hardship:
      return 'Hardship';
    case 'naturalDisaster':
    case GqlPaymentDeferralReason.NaturalDisaster:
      return 'Natural Disaster';
    case 'covid':
    case GqlPaymentDeferralReason.Covid:
      return 'COVID';
    case 'failedRepaymentPlan':
    case GqlPaymentDeferralReason.FailedRepaymentPlan:
      return 'Failed repayment plan';
    case 'postForbearancePlan':
    case GqlPaymentDeferralReason.PostForbearancePlan:
      return 'Post-forbearance workout plan';
    case 'other':
    case GqlPaymentDeferralReason.Other:
      return 'Other';
    default:
      assertNever(reason);
  }
};
